import { cva } from 'class-variance-authority';
import { getCardAttributes, getUserExclusiveCardAttributes } from '@pkgs/components/utils/propertyCardUtils';
import { type ObjectTypeCategory } from '@pkgs/components/hooks/stores/search/slices/objectTypeFilterSlice';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useDefaultSearchResultCardContext, useUAExclusiveSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardContent.module.css';

const attributesVariants = cva(styles.attributes, {
  variants: {
    variant: {
      default: null,
      preview: styles.previewAttributes,
    },
  },
});

export const SearchResultCardAttributes = () => {
  const {
    attributes: additionalAttributes,
    isApproximateLocation,
    language,
    listing,
    measurementSystem,
    translationResolver: t,
    variant,
  } = useDefaultSearchResultCardContext();

  const objectTypeCategory: ObjectTypeCategory = listing.isDevelopmentProject ? 'development' : listing.businessArea;
  const attributes = [
    ...(additionalAttributes ?? []),
    ...getCardAttributes({ objectTypeCategory, listing, translationResolver: t, language, measurementSystem }),
  ];

  return (
    <ul className={attributesVariants({ variant })} data-is-approximate-location={isApproximateLocation}>
      {attributes.map((attribute) => (
        <li className={styles.attribute} key={attribute.id}>
          <Copy
            className={styles.attributeItem}
            size="m"
            as="span"
            text={attribute.label}
            testId={`search-components_result-card_attribute_${attribute.id}`}
          />
        </li>
      ))}
    </ul>
  );
};

export const ExclusiveSearchResultCardAttributes = () => {
  const {
    attributes: additionalAttributes,
    isApproximateLocation,
    language,
    listing,
    measurementSystem,
    translationResolver: t,
    variant,
  } = useUAExclusiveSearchResultCardContext();

  const attributes = [...(additionalAttributes ?? []), ...getUserExclusiveCardAttributes({ property: listing, t, language, measurementSystem })];

  return (
    <ul className={attributesVariants({ variant })} data-is-approximate-location={isApproximateLocation}>
      {attributes.map((attribute) => (
        <li className={styles.attribute} key={attribute.id}>
          <Copy
            className={styles.attributeItem}
            size="m"
            as="span"
            text={attribute.label}
            testId={`search-components_result-card_attribute_${attribute.id}`}
          />
        </li>
      ))}
    </ul>
  );
};
